import React from "react";

const Icon = ({
  title,
  height = 24,
  width = 24,
  fill = "white",
  viewBox = "0 0 24 24",
}) => {
  const svgPaths = {
    pasteBelow: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 21H3m15-10-6 6m0 0-6-6m6 6V3"
      />
    ),
    arrorInCircle: (
      <path
        d="M12 8L8 12M8 12L12 16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    transformToMenu: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 12H9m12-6H9m12 12H9m-4-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      />
    ),
    close: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18 6 6 18M6 6l12 12"
      />
    ),
    copy: (
      <path
        d="M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    addToMenu: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m9 16 3-3m0 0 3 3m-3-3v7M22 9H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
      />
    ),
    addSegment: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 10.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22H12m2-11H8m2 4H8m8-8H8m10 14v-6m-3 3h6"
      />
    ),
    addChoices: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M7.5 12h.01M12 12h.01m4.49 0h.01M8 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
      />
    ),
    deleteChoices: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M18.57 20a2.286 2.286 0 0 0 2.287-2.286v-4.571L22 12l-1.143-1.143V6.286A2.285 2.285 0 0 0 18.57 4M5.429 4a2.285 2.285 0 0 0-2.286 2.286v4.571L2 12l1.143 1.143v4.571A2.285 2.285 0 0 0 5.429 20M15 9l-6 6m0-6 6 6"
      />
    ),
    backspace: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
        d="m12 9.5 5 5m0-5-5 5m-7.492-.545 2.932 3.8c.352.457.528.685.75.85a2 2 0 0 0 .652.32c.266.075.554.075 1.131.075H17.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 17.48 21 16.92 21 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.481 5 18.92 5 17.8 5H9.973c-.577 0-.865 0-1.13.075a2 2 0 0 0-.653.32c-.222.165-.398.393-.75.85l-2.932 3.8c-.54.7-.81 1.05-.913 1.435a2 2 0 0 0 0 1.04c.104.385.374.735.913 1.435Z"
      />
    ),
    remove: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m9 17 3 3m0 0 3-3m-3 3v-7m10-4H2m3.5 9h-.3c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 5.52 22 6.08 22 7.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 18 19.92 18 18.8 18h-.3"
      />
    ),
    edit: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M11 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.31C20 19.72 20 18.88 20 17.2V13M8 16h1.675c.489 0 .733 0 .963-.055a2 2 0 0 0 .579-.24c.201-.123.374-.296.72-.642L21.5 5.5a2.121 2.121 0 0 0-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.964V16Z"
      />
    ),
    notifications: (
      <path
        fill={fill}
        fillRule="evenodd"
        d="M9.297 4.727v.526c-2.69 1.103-4.57 4.726-4.501 7.866v1.744c-1.377 1.77-1.296 4.41 2.14 4.41h2.36c0 .723.283 1.417.784 1.928a2.65 2.65 0 0 0 1.892.799c.71 0 1.39-.287 1.892-.799a2.755 2.755 0 0 0 .784-1.928h2.367c3.43 0 3.479-2.645 2.102-4.415l.038-1.736c.07-3.144-1.813-6.77-4.508-7.872v-.523c0-.723-.281-1.417-.783-1.928A2.65 2.65 0 0 0 11.972 2c-.71 0-1.39.287-1.892.799a2.754 2.754 0 0 0-.783 1.928Zm3.567 0s0 .037-.002.055a7.12 7.12 0 0 0-1.78.001.918.918 0 0 1 .26-.699.883.883 0 0 1 1.26 0c.168.17.262.402.262.643ZM11.08 19.273c0 .24.094.472.261.643a.884.884 0 0 0 1.262 0 .919.919 0 0 0 .26-.643H11.08Zm5.935-1.819c.762 0 1.173-.91.678-1.5a1.54 1.54 0 0 1-.361-1.025l.04-1.848c.068-3.087-2.368-6.536-5.396-6.536S6.512 9.993 6.579 13.08l.04 1.85a1.54 1.54 0 0 1-.36 1.025c-.497.59-.086 1.5.676 1.5h10.08ZM16.98 3.202a1 1 0 0 1 1.392-.252c1.147.795 2.524 2.703 3.275 4.963a1 1 0 0 1-1.898.63c-.66-1.984-1.827-3.471-2.517-3.95a1 1 0 0 1-.252-1.391ZM5.43 2.95a1 1 0 1 1 1.14 1.644c-.69.478-1.857 1.965-2.518 3.95a1 1 0 0 1-1.897-.631c.751-2.26 2.128-4.168 3.275-4.963Z"
        clipRule="evenodd"
      />
    ),
    comment: (
      <path
        fill={fill}
        fillRule="evenodd"
        d="M24 12a2 2 0 1 0 .001 4.001A2 2 0 0 0 24 12Zm-8 14c-1.168 0-2.296-.136-3.38-.367l-4.708 2.83.063-4.639C4.366 21.654 2 18.066 2 14 2 7.373 8.268 2 16 2s14 5.373 14 12c0 6.628-6.268 12-14 12Zm0-26C7.164 0 0 6.269 0 14c0 4.419 2.345 8.354 6 10.919V32l7.009-4.253c.97.16 1.968.253 2.991.253 8.836 0 16-6.268 16-14 0-7.731-7.164-14-16-14ZM8 12a2 2 0 1 0 .001 4.001A2 2 0 0 0 8 12Zm8 0a2 2 0 1 0 .001 4.001A2 2 0 0 0 16 12Z"
      />
    ),
    profile: (
      <g fill={fill}>
        <path d="M22 12c0-5.51-4.49-10-10-10S2 6.49 2 12c0 2.9 1.25 5.51 3.23 7.34 0 .01 0 .01-.01.02.1.1.22.18.32.27.06.05.11.1.17.14.18.15.38.29.57.43l.2.14c.19.13.39.25.6.36.07.04.15.09.22.13.2.11.41.21.63.3.08.04.16.08.24.11.22.09.44.17.66.24.08.03.16.06.24.08.24.07.48.13.72.19.07.02.14.04.22.05.28.06.56.1.85.13.04 0 .08.01.12.02.34.03.68.05 1.02.05.34 0 .68-.02 1.01-.05.04 0 .08-.01.12-.02.29-.03.57-.07.85-.13.07-.01.14-.04.22-.05.24-.06.49-.11.72-.19.08-.03.16-.06.24-.08.22-.08.45-.15.66-.24.08-.03.16-.07.24-.11.21-.09.42-.19.63-.3.08-.04.15-.09.22-.13.2-.12.4-.23.6-.36.07-.04.13-.09.2-.14.2-.14.39-.28.57-.43.06-.05.11-.1.17-.14.11-.09.22-.18.32-.27 0-.01 0-.01-.01-.02C20.75 17.51 22 14.9 22 12Zm-5.06 4.97c-2.71-1.82-7.15-1.82-9.88 0-.44.29-.8.63-1.1 1A8.48 8.48 0 0 1 3.5 12c0-4.69 3.81-8.5 8.5-8.5 4.69 0 8.5 3.81 8.5 8.5 0 2.32-.94 4.43-2.46 5.97-.29-.37-.66-.71-1.1-1Z" />
        <path d="M12 6.93c-2.07 0-3.75 1.68-3.75 3.75 0 2.03 1.59 3.68 3.7 3.74h.18a3.743 3.743 0 0 0 3.62-3.74c0-2.07-1.68-3.75-3.75-3.75Z" />
      </g>
    ),
    save: (
      <g fill={fill}>
        {" "}
        <path d="M16.765 2c1.187 0 1.363.06 1.51.168L21.662 4.7a.845.845 0 0 1 .339.677v15.78a.844.844 0 0 1-.844.844H2.844A.844.844 0 0 1 2 21.156V2.844A.844.844 0 0 1 2.844 2zM17 21v-7H7v7zM14 3v3h1V3zM7 3v6h10V3h-1v4h-3V3zM3 21h3v-8h12v8h3V5.452l-3-2.278v6.17a.769.769 0 0 1-.844.656H6.844A.769.769 0 0 1 6 9.344V3H3z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </g>
    ),
    like: (
      <g fill={fill}>
        <path d="M8.39 18.49V8.33c0-.4.12-.79.34-1.12l2.73-4.06c.43-.65 1.5-1.11 2.41-.77.98.33 1.63 1.43 1.42 2.41l-.52 3.27c-.04.3.04.57.21.78.17.19.42.31.69.31h4.11c.79 0 1.47.32 1.87.88.38.54.45 1.24.2 1.95l-2.46 7.49c-.31 1.24-1.66 2.25-3 2.25h-3.9c-.67 0-1.61-.23-2.04-.66l-1.28-.99c-.49-.37-.78-.96-.78-1.58ZM5.21 6.379H4.18c-1.55 0-2.18.6-2.18 2.08v10.06c0 1.48.63 2.08 2.18 2.08h1.03c1.55 0 2.18-.6 2.18-2.08V8.459c0-1.48-.63-2.08-2.18-2.08Z" />
      </g>
    ),
    xray: (
      <g fill={fill}>
        <path d="M118 31v194l128 29V2L118 31zm12 9.59 104-23.57v221.96l-104-23.57V40.59zM2 30v224h39v-30h12c18.085 0 31.965-15.162 31.965-33.346v-19.666h14.033c3.755 0 6.72-2.965 6.72-6.621 0-.889-.099-1.779-.494-2.569l-19.468-47.435s-1.779-18.085-3.36-25.002C75.181 58.132 40.751 30 3 30H2zm52.824 86.635c0-4.941 3.953-8.894 8.894-8.894s8.894 3.953 8.894 8.894c0 4.941-3.953 8.894-8.894 8.894s-8.894-3.953-8.894-8.894zm165.941 6.99-35.571.414v12.445l31.369.359c1.959.022 3.482 2.027 3.482 4.456 0 2.429-1.613 4.373-3.482 4.323l-31.369-.841v12.445l30.218 1.507c1.329.066 3.289 1.816 3.289 4.46 0 23.241-1.694 34.057-11.393 32.921-10.122-1.185-11.609-28.425-22.114-30.176v24.475l-15.401-1.715V165.02c-8.826 1.001-10.556 25.56-18.685 24.607-7.606-.892-9.355-10.729-9.355-30.849 0-2.289 1.546-3.642 2.56-3.591l25.48 1.271v-12.09l-26.426-.708c-1.48-.04-2.617-1.783-2.617-3.877s1.204-3.793 2.617-3.777l26.426.302v-12.09l-29.71.345c-1.46.017-2.583-1.672-2.583-3.752s1.189-3.814 2.583-3.851l29.71-.802v-12.09l-27.973 1.4c-1.47.074-2.601-1.578-2.601-3.665 0-2.087 1.197-3.873 2.601-3.965l27.973-1.83V82.911L147.79 84.9c-1.506.136-2.664-1.487-2.664-3.599s1.226-3.97 2.664-4.122l22.003-2.327v-6.045L185.194 67v6.222l25.658-2.714c1.92-.203 3.413 1.606 3.413 4.011 0 2.404-1.493 4.507-3.413 4.68l-25.658 2.32v13.482l33.239-2.175c1.972-.129 3.505 1.764 3.505 4.201s-1.623 4.512-3.505 4.606l-33.239 1.664v12.445l35.571-.96c1.988-.054 3.534 1.907 3.534 4.353 0 2.447-1.546 4.467-3.534 4.49z" />
      </g>
    ),
    reply: (
      <g fill={fill}>
        <path
          stroke="#535358"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m5.608 12.526 7.04-6.454C13.931 4.896 16 5.806 16 7.546V11c13 0 11 16 11 16s-4-10-11-10v3.453c0 1.74-2.069 2.65-3.351 1.475l-7.04-6.454a2 2 0 0 1 0-2.948z"
        />
      </g>
    ),
    refresh: (
      <path
        fill={fill}
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2ZM5.25 11.89c.03-1.76.73-3.42 1.97-4.66A6.718 6.718 0 0 1 12 5.25c1.8 0 3.5.7 4.77 1.98.03.03.06.07.09.11v-.86c0-.41.34-.75.75-.75s.75.34.75.75v2.65c0 .41-.34.75-.75.75h-2.65c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.83c-.03-.03-.05-.06-.08-.09A5.22 5.22 0 0 0 12 6.75c-1.4 0-2.72.55-3.71 1.54-.97.97-1.51 2.26-1.53 3.63a.76.76 0 0 1-.76.73h-.01c-.41 0-.74-.35-.74-.76Zm11.52 4.88A6.719 6.719 0 0 1 12 18.75c-1.8 0-3.5-.7-4.77-1.98-.03-.03-.06-.07-.09-.11v.85c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.65c0-.41.34-.75.75-.75h2.65c.41 0 .75.34.75.75s-.34.75-.75.75h-.83c.03.03.05.06.08.09A5.22 5.22 0 0 0 12 17.24c1.4 0 2.72-.55 3.71-1.54.98-.98 1.53-2.29 1.53-3.69 0-.41.34-.75.75-.75s.75.34.75.75c0 1.81-.7 3.5-1.97 4.76Z"
      />
    ),
    buttonSearch: (
      <>
        <path fill="transparent" d="M0 0h24v24H0z" />
        <path
          fill={fill}
          fillRule="evenodd"
          d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7-.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM11.5 7a4.5 4.5 0 1 0 2.396 8.31l1.397 1.397a1 1 0 0 0 1.414-1.414l-1.397-1.397A4.5 4.5 0 0 0 11.5 7Z"
          clipRule="evenodd"
        />
      </>
    ),
    buttonAdd: (
      <>
        {" "}
        <path fill="transparent" d="M0 0h24v24H0z" />
        <path
          fill={fill}
          fillRule="evenodd"
          d="M13 9a1 1 0 1 0-2 0v2H9a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V9ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z"
          clipRule="evenodd"
        />
      </>
    ),
    mri: (
      <g fill={fill}>
        <path d="M11 0v10.122c0 1.329-1.122 2.409-2.5 2.409S6 11.451 6 10.122V0H1v10.432C1 14.698 4.864 17 8.5 17s7.5-2.302 7.5-6.568V0h-5zm4 1v3h-3V1h3zM5 1v3H2V1h3zm3.5 15C5.887 16 2 14.517 2 10.432V5h3v5.122c0 1.88 1.57 3.409 3.5 3.409s3.5-1.529 3.5-3.409V5h3v5.432C15 14.517 11.113 16 8.5 16z" />
      </g>
    ),
    settings: (
      <g stroke={fill} strokeWidth={1.5}>
        <circle cx={12} cy={12} r={3} />
        <path
          strokeLinecap="round"
          d="M3.661 10.64c.473.296.777.802.777 1.36s-.304 1.064-.777 1.36c-.321.203-.529.364-.676.556a2 2 0 0 0-.396 1.479c.052.394.285.798.75 1.605.467.807.7 1.21 1.015 1.453a2 2 0 0 0 1.479.396c.24-.032.483-.13.819-.308a1.617 1.617 0 0 1 1.567.008c.483.28.77.795.79 1.353.014.38.05.64.143.863a2 2 0 0 0 1.083 1.083C10.602 22 11.068 22 12 22c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.092-.223.129-.483.143-.863.02-.558.307-1.074.79-1.353a1.617 1.617 0 0 1 1.567-.008c.336.178.58.276.82.308a2 2 0 0 0 1.478-.396c.315-.242.548-.646 1.014-1.453.208-.36.369-.639.489-.873m-.81-2.766a1.617 1.617 0 0 1-.777-1.36c0-.559.304-1.065.777-1.362.321-.202.528-.363.676-.555a2 2 0 0 0 .396-1.479c-.052-.394-.285-.798-.75-1.605-.467-.807-.7-1.21-1.015-1.453a2 2 0 0 0-1.479-.396c-.24.032-.483.13-.82.308a1.617 1.617 0 0 1-1.566-.008 1.617 1.617 0 0 1-.79-1.353c-.014-.38-.05-.64-.143-.863a2 2 0 0 0-1.083-1.083C13.398 2 12.932 2 12 2c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083c-.092.223-.129.483-.143.863a1.617 1.617 0 0 1-.79 1.353 1.617 1.617 0 0 1-1.567.008c-.336-.178-.58-.276-.82-.308a2 2 0 0 0-1.478.396C4.04 5.79 3.806 6.193 3.34 7c-.208.36-.369.639-.489.873"
        />
      </g>
    ),
    import: (
      <g fill={fill}>
        <circle cx={61.239} cy={34.712} r={25.907} />
        <path d="m309.882 282.054-27.199-76.042V86.185c0-9.665-7.835-17.501-17.501-17.501h-31.209c-9.665 0-17.501 7.835-17.501 17.501v43.533l14.849-5.147 20.151-36.19-11.895 46.029-40.486 14.032c-6.398 2.218-10.204 9.061-8.244 15.543 1.648 5.45 6.628 8.897 11.965 8.898a12.5 12.5 0 0 0 4.098-.692l47.187-16.354a12.501 12.501 0 0 0 8.009-8.683l13.135-50.828-1.134 50.935c-.02.885-.222 2.311-.454 3.165a24.448 24.448 0 0 1-15.626 16.75l-38.301 13.275-3.481 35.866c-.047.483-.07.969-.07 1.455l.025 69.106c.003 8.282 6.718 14.995 15 14.995h.006c8.284-.003 14.997-6.722 14.994-15.006l-.025-68.377 4.013-41.352a1.286 1.286 0 0 1 2.564.065l1.474 32.322c.065 1.402.327 2.789.778 4.118l26.468 78.046c2.119 6.249 7.952 10.187 14.203 10.187 1.598 0 3.223-.257 4.819-.799 7.846-2.66 12.049-11.177 9.388-19.023zM153.927 165.975h20.481a11.8 11.8 0 0 0 4.378-.845c-1.685-8.499 1.303-17.126 7.474-22.802v-7.408h-32.333v31.055zM128.93 165.975h12.997v-11.636a24.512 24.512 0 0 1-12.997 11.636z" />
        <circle cx={249.441} cy={34.712} r={25.907} />
        <path d="m121.199 130.636-42.575-4.837-21.673-42.313 27.578 30.906 9.679 1.1V86.185c0-9.665-7.835-17.501-17.501-17.501H45.498c-9.665 0-17.501 7.835-17.501 17.501v134.312L1.135 281.158c-3.155 7.659.495 16.427 8.155 19.583a14.94 14.94 0 0 0 5.708 1.135c5.896 0 11.489-3.5 13.875-9.29l26-63.105a15.004 15.004 0 0 0 1.118-5.087l1.874-45.481a3.064 3.064 0 0 1 5.935-.929l14.84 40.456-13.834 65.324c-1.716 8.104 3.463 16.065 11.567 17.782 1.048.222 2.093.328 3.122.328 6.937 0 13.165-4.839 14.66-11.896l14.728-69.546a14.997 14.997 0 0 0-.592-8.272l-14.083-38.396v-8.957l-26.42-3.002a24.446 24.446 0 0 1-18.911-12.926c-.413-.783-.922-2.13-1.135-2.989L35.495 96.436l23.934 46.725a12.499 12.499 0 0 0 9.715 6.721l49.622 5.638c1.427.162 2.824.077 4.15-.221 5.208-1.169 9.313-5.621 9.729-11.299.493-6.754-4.718-12.599-11.446-13.364z" />
        <path d="M174.408 92.475h-5.132c1.124-.632 2.112-1.327 2.885-2.1 6.268-6.269 6.268-16.47-.001-22.74-6.27-6.268-16.47-6.267-22.739 0v.001c-.534.534-1.028 1.183-1.494 1.895-.466-.712-.96-1.36-1.494-1.895-6.268-6.27-16.469-6.271-22.74 0-6.268 6.27-6.268 16.47.001 22.739.773.773 1.761 1.468 2.885 2.1h-5.133c-6.546 0-11.852 5.306-11.852 11.852v12.913l13.348 1.517a24.379 24.379 0 0 1 11.147 4.163h7.838V91.865h12v31.056h32.333v-18.593c0-6.546-5.306-11.853-11.852-11.853zm-42.229-10.584a4.085 4.085 0 0 1-.001-5.77 4.068 4.068 0 0 1 2.886-1.193 4.07 4.07 0 0 1 2.854 1.162c.828 1.021 1.885 4.421 2.755 8.526-4.125-.871-7.529-1.924-8.494-2.725zm31.546-.047c-.996.831-4.413 1.895-8.542 2.771.87-4.104 1.926-7.504 2.754-8.524a4.083 4.083 0 0 1 5.738.03c1.591 1.591 1.591 4.179.05 5.723z" />
      </g>
    ),
    ct: (
      <g fill={fill}>
        <path d="M57.786 21.862c-.007-.052-.006-.104-.015-.156-.023-.135-.055-.267-.081-.401a15.722 15.722 0 0 0-.263-1.123l-.033-.123C54.643 10.223 42.784 2.996 28.92 2.996c-.188 0-.371.016-.558.018-.495.007-.986.023-1.475.048-.284.015-.569.027-.851.048a37.179 37.179 0 0 0-2.653.292c-.579.083-1.153.176-1.719.285-.289.055-.572.119-.857.181a37.246 37.246 0 0 0-2.513.64 34.352 34.352 0 0 0-2.649.895c-.183.071-.369.138-.55.211C9.427 7.898 4.881 11.547 2.312 16.03l-.051.087c-.257.455-.492.917-.707 1.388-.096.208-.194.415-.281.625a18.797 18.797 0 0 0-.7 2.037c-.018.067-.046.13-.063.198-.018.072-.022.144-.037.216A16.068 16.068 0 0 0 0 24.414l.015 9.628c0 11.754 12.697 20.962 28.906 20.962C44.955 55.004 58 45.415 58 33.628v-9.216c0-.863-.078-1.713-.214-2.55zm-3.062 2.634c-1.457.888-2.059 3.809-2.75 7.838-.177 1.031-.344 2.004-.507 2.646-.091.36-.255.644-.364.77-1.904-.542-3.465-.431-4.639.331-1.834 1.188-2.149 3.556-2.318 4.829-.011.084-.05.145-.117.179a.241.241 0 0 1-.228-.006c-.098-.065-.317-.359-.478-.574-.713-.956-1.904-2.563-4.472-2.276-2.091.23-3.191 2.492-4.163 4.488-.347.712-.674 1.384-.983 1.817-.376.528-1.123.728-1.773.484a5.244 5.244 0 0 1-.142-.376c-.271-.773-.833-2.382-3.088-2.42-1.756-.024-2.561 1.388-3.019 2.234-.122.227-.307.569-.369.628-.562.279-1.189.13-1.523-.368-.207-.309-.2-1.171-.194-1.863.011-1.323.024-2.971-1.134-3.967-.591-.509-1.383-.761-2.4-.761a8.08 8.08 0 0 0-1.26.109c-1.29.206-2.376 1.176-3.249 1.955-.316.282-.709.634-.876.711a.28.28 0 0 1-.274-.006.407.407 0 0 1-.202-.315c-.055-.418-.162-.815-.29-1.292-.728-2.716-3.696-2.851-5.47-2.931-.502-.022-.976-.044-1.254-.109-.606-.141-1.086-.654-1.252-1.34-.092-.383-.141-1.479-.188-2.539-.174-3.919-.382-6.55-1.632-7.386-1.346-.9-2.007-2.48-1.691-3.977.026-.104.05-.209.078-.312a15.145 15.145 0 0 1 .613-1.799c.158-.386.329-.767.518-1.142.11-.217.231-.431.352-.644a18.05 18.05 0 0 1 1.161-1.79c.06-.081.119-.162.18-.242 2.48-3.247 6.211-5.93 10.723-7.709.124-.049.251-.094.376-.141a32.559 32.559 0 0 1 3.883-1.202c.328-.08.657-.156.99-.227.292-.062.584-.125.881-.181a34.935 34.935 0 0 1 2.41-.362 35.902 35.902 0 0 1 1.622-.156c.279-.02.561-.032.842-.046.431-.021.864-.035 1.299-.042.19-.003.379-.01.57-.01 12.579 0 23.18 6.179 26.209 14.524.022.06.041.121.061.181.082.234.159.47.228.708.03.102.056.205.083.308.054.199.105.399.15.601.028.123.052.248.076.372.026.134.049.268.072.403.142.968-.272 1.903-1.078 2.395zM28.921 53.004c-15.087 0-26.906-8.329-26.906-18.962l-.013-8.246c.292.302.606.587.966.826.547.589.71 4.27.78 5.841.059 1.312.104 2.349.242 2.919.345 1.426 1.397 2.507 2.745 2.818.456.106.994.131 1.616.159 1.858.084 3.306.244 3.655 1.546.09.335.175.651.212.938.1.767.557 1.443 1.221 1.809a2.287 2.287 0 0 0 2.081.068c.437-.202.868-.588 1.367-1.033.678-.605 1.521-1.358 2.233-1.473 1-.158 1.707-.094 2.04.193.456.392.446 1.477.438 2.434-.009 1.068-.018 2.172.533 2.994a3.124 3.124 0 0 0 2.607 1.395c.492 0 .994-.113 1.469-.351.608-.303.928-.896 1.237-1.468.484-.896.72-1.21 1.226-1.185.861.015.978.349 1.233 1.08.184.525.413 1.181 1.092 1.491 1.554.705 3.378.246 4.339-1.098.406-.569.769-1.315 1.153-2.104.708-1.455 1.589-3.266 2.583-3.375 1.421-.158 2.021.64 2.65 1.483.342.459.666.893 1.138 1.142a2.25 2.25 0 0 0 2.088.02 2.231 2.231 0 0 0 1.182-1.692c.136-1.02.362-2.727 1.422-3.413.691-.446 1.742-.465 3.125-.052.459.137.927.083 1.353-.16.922-.522 1.288-1.721 1.377-2.075.182-.719.348-1.684.54-2.8.333-1.943 1.027-5.986 1.82-6.47.083-.051.156-.113.235-.169v7.594c0 10.684-12.147 19.376-27.079 19.376z" />
        <path d="M28.496 16.504c-6.168 0-11 3.075-11 7 0 .696.173 1.396.506 2.084.011.028.009.058.023.085 1.442 2.89 5.65 4.831 10.472 4.831s9.03-1.941 10.472-4.831c.013-.027.012-.057.023-.085.333-.688.506-1.389.506-2.084-.002-3.925-4.833-7-11.002-7zm0 2c4.878 0 9 2.29 9 5 0 .129-.01.257-.031.387-.008-.003-.018-.005-.026-.009a22.164 22.164 0 0 0-1.892-.623c-.097-.028-.192-.057-.29-.083a24.137 24.137 0 0 0-2.275-.494 26.303 26.303 0 0 0-2.014-.264c-.096-.009-.193-.013-.29-.021-.719-.057-1.446-.093-2.181-.093s-1.462.036-2.181.093c-.096.008-.194.012-.29.021a26.303 26.303 0 0 0-4.289.758c-.098.026-.193.055-.29.083-.647.184-1.281.388-1.892.623-.008.003-.018.005-.026.009a2.413 2.413 0 0 1-.031-.387c-.002-2.71 4.12-5 8.998-5zm-8.058 7.182c.034-.013.07-.024.105-.036.517-.19 1.052-.359 1.598-.509.086-.024.171-.05.258-.073a22.288 22.288 0 0 1 1.716-.374c.117-.021.233-.042.35-.061a24.612 24.612 0 0 1 1.789-.227c.099-.009.2-.014.299-.022.641-.049 1.287-.08 1.943-.08s1.302.032 1.943.08c.1.008.2.013.299.022a23.552 23.552 0 0 1 2.139.288c.583.105 1.157.227 1.716.374.087.023.171.049.258.073.546.151 1.08.319 1.598.509.035.013.071.023.105.036-1.512 1.697-4.621 2.818-8.058 2.818s-6.547-1.121-8.058-2.818z" />
      </g>
    ),
    us: (
      <g fill="transparent">
        <>
          <g clipPath="url(#a)">
            <path fill="transparent" d="M0 0h24v24H0z" />
            <path
              stroke={fill}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 16V8h3l5-4v16l-5-4H3ZM13 9s2 .5 2 3-2 3-2 3M15 7s3 .833 3 5-3 5-3 5"
            />
            <path
              stroke={fill}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 5s4 1.167 4 7-4 7-4 7"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="transparent" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      </g>
    ),
    jesus: (
      <>
        {" "}
        <path
          d="M256 440.558c-121.463 0-220.279-98.816-220.279-220.279S134.537 0 256 0s220.279 98.816 220.279 220.279S377.463 440.558 256 440.558zm0-404.837c-101.765 0-184.558 82.793-184.558 184.558S154.235 404.837 256 404.837s184.558-82.793 184.558-184.558S357.765 35.721 256 35.721z"
          style={{
            fill: "#ffda44",
          }}
        />
        <path
          d="M256 0v35.721c101.765 0 184.558 82.793 184.558 184.558S357.765 404.837 256 404.837v35.721c121.463 0 220.279-98.816 220.279-220.279S377.463 0 256 0z"
          style={{
            fill: "#ffad41",
          }}
        />
        <path
          d="M298.865 494.14h-85.73c-55.01 0-100.019-45.008-100.019-100.019V220.279c0-55.009 45.008-100.019 100.019-100.019h85.73c55.01 0 100.019 45.01 100.019 100.019v173.842c0 55.01-45.009 100.019-100.019 100.019z"
          style={{
            fill: "#ffe6c6",
          }}
        />
        <circle
          cx={190.512}
          cy={309.581}
          r={17.86}
          style={{
            fill: "#50412e",
          }}
        />
        <path
          d="M298.865 120.26H256v373.88h42.865c55.01 0 100.019-45.008 100.019-100.019V220.279c0-55.01-45.009-100.019-100.019-100.019z"
          style={{
            fill: "#ffd6a0",
          }}
        />
        <circle
          cx={321.488}
          cy={309.581}
          r={17.86}
          style={{
            fill: "#50412e",
          }}
        />
        <path
          d="M298.865 102.4h-85.73c-64.999 0-117.879 52.88-117.879 117.879v173.842C95.256 459.12 148.136 512 213.135 512h85.73c64.999 0 117.879-52.88 117.879-117.879V220.279c0-64.999-52.88-117.879-117.879-117.879zm33.617 276.156c-12.644-17.519-33.222-28.491-55.32-28.491h-42.326c-22.098 0-42.676 10.972-55.32 28.491-29.141-13.104-48.54-42.247-48.54-74.928v-53.581h20.512c44.201 0 83.002-23.557 104.511-58.774 21.509 35.217 60.31 58.774 104.511 58.774h20.512v53.581c.001 32.681-19.398 61.825-48.54 74.928z"
          style={{
            fill: "#a0815c",
          }}
        />
        <path
          d="M298.865 102.4H256v88.872c21.509 35.217 60.31 58.774 104.511 58.774h20.512v53.581c0 32.681-19.399 61.825-48.541 74.928-12.644-17.519-33.222-28.491-55.32-28.491H256V512h42.865c64.999 0 117.879-52.88 117.879-117.879V220.279c0-64.999-52.88-117.879-117.879-117.879z"
          style={{
            fill: "#786145",
          }}
        />
        <path
          d="M285.767 416.744c0 16.44-13.327 29.767-29.767 29.767-16.441 0-29.767-13.327-29.767-29.767"
          style={{
            fill: "#ffe6c6",
          }}
        />
      </>
    ),
    jesus2: (
      <g id="SVGRepo_iconCarrier">
        <defs>
          <style>
            {
              ".b,.d{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.b{fill:#ffed09;stroke:#d38509}.c{fill:#1c1c1c}.d{fill:none;stroke:#1c1c1c}"
            }
          </style>
        </defs>
        <title />
        <path
          d="M50 26h-3.12a18 18 0 1 0-35.7.41A10 10 0 0 0 14 46h36a10 10 0 0 0 0-20Z"
          style={{
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            fill: "#e5e4e4",
            stroke: "#818180",
          }}
        />
        <path
          d="m48 33-6 15h5v10l8-14-6.83-.17L48 33zM14 35 8 50h5v10l8-14-6.83-.17L14 35z"
          className="b"
        />
        <circle cx={20} cy={24} r={2} className="c" />
        <circle cx={36} cy={24} r={2} className="c" />
        <path
          d="M36 30.8a6.4 6.4 0 0 1-6.4 6.4h-1.2a6.4 6.4 0 0 1-6.4-6.4h14Z"
          className="c"
        />
        <path d="m33 24 6-4M23.58 24l-6-4" className="d" />
      </g>
    ),
    workingOnIt: (
      <g fill={fill}>
        <path d="M92.8 134.1h133.5v11.2H92.8z" />
        <circle cx={79.9} cy={29.4} r={24.6} />
        <path d="M117.2 151H75.7v-30.8L54.5 83.7c-.8-1.5-.2-3.3 1-4.2 1.5-.8 3.3-.2 4.2 1l24.6 42.3c1.9 3.1 5.2 5.4 9.2 5.4h42.3c6 0 10.8-5 10.8-10.8 0-6-5-10.8-10.8-10.8l-35.4.4-28.2-47.4c-2.1-3.7-6.2-5.8-11.2-5.8-.6 0-2.3.2-2.9.4-.6.2-1.7.4-2.3.6-20.6 6.9-36.9 39.6-36.9 73.3-.2 10.2 0 18.7.6 26.9-.8 9.8 5 19.4 14.6 22.9 2.5.8 5 1.5 7.5 1.5h61.7V237c0 7.9 6.2 14 14 14 7.9 0 14-6.2 14-14v-71.9c0-3.5-1.5-7.3-4.2-9.8-3-2.8-6.6-4.3-9.9-4.3zM212 126l.2.2L238 62.9l-8.3-3.5-23.8 58.3h-53.5v9.2H212z" />
      </g>
    ),
    yoursProfile: (
      <g fill={fill}>
        <path d="M22 12c0-5.51-4.49-10-10-10S2 6.49 2 12c0 2.9 1.25 5.51 3.23 7.34 0 .01 0 .01-.01.02.1.1.22.18.32.27.06.05.11.1.17.14.18.15.38.29.57.43l.2.14c.19.13.39.25.6.36.07.04.15.09.22.13.2.11.41.21.63.3.08.04.16.08.24.11.22.09.44.17.66.24.08.03.16.06.24.08.24.07.48.13.72.19.07.02.14.04.22.05.28.06.56.1.85.13.04 0 .08.01.12.02.34.03.68.05 1.02.05.34 0 .68-.02 1.01-.05.04 0 .08-.01.12-.02.29-.03.57-.07.85-.13.07-.01.14-.04.22-.05.24-.06.49-.11.72-.19.08-.03.16-.06.24-.08.22-.08.45-.15.66-.24.08-.03.16-.07.24-.11.21-.09.42-.19.63-.3.08-.04.15-.09.22-.13.2-.12.4-.23.6-.36.07-.04.13-.09.2-.14.2-.14.39-.28.57-.43.06-.05.11-.1.17-.14.11-.09.22-.18.32-.27 0-.01 0-.01-.01-.02C20.75 17.51 22 14.9 22 12Zm-5.06 4.97c-2.71-1.82-7.15-1.82-9.88 0-.44.29-.8.63-1.1 1A8.48 8.48 0 0 1 3.5 12c0-4.69 3.81-8.5 8.5-8.5 4.69 0 8.5 3.81 8.5 8.5 0 2.32-.94 4.43-2.46 5.97-.29-.37-.66-.71-1.1-1Z" />
        <path d="M12 6.93c-2.07 0-3.75 1.68-3.75 3.75 0 2.03 1.59 3.68 3.7 3.74h.18a3.743 3.743 0 0 0 3.62-3.74c0-2.07-1.68-3.75-3.75-3.75Z" />
      </g>
    ),
    newIdea: (
      <g fill={fill}>
        <path d="M22.746 31.173h-5.538a.912.912 0 0 1-.912-.912v-.641c.006-.551-.021-.938-.079-1.154-.311-1.139-1.134-2.094-1.931-3.02a23.085 23.085 0 0 1-.739-.883 8.114 8.114 0 0 1-1.757-5.061c0-4.526 3.684-8.207 8.21-8.207 4.525 0 8.208 3.681 8.208 8.207a8.097 8.097 0 0 1-1.757 5.063c-.201.258-.433.528-.675.813-.816.96-1.727 2.031-2.041 3.162-.055.202-.082.565-.078 1.073v.646a.912.912 0 0 1-.911.914zm-4.624-1.826h3.712c.01-.71.079-1.06.142-1.288.423-1.523 1.471-2.76 2.396-3.846.243-.286.456-.536.645-.774a6.309 6.309 0 0 0 1.366-3.936c0-3.52-2.862-6.384-6.382-6.384s-6.384 2.864-6.384 6.384c0 1.438.472 2.798 1.366 3.934.211.27.442.535.687.818.843.979 1.888 2.192 2.31 3.733.062.241.134.608.142 1.359zM22.746 33.588h-5.538a.912.912 0 0 1 0-1.825h5.538a.912.912 0 0 1 0 1.825zM21.362 36h-2.769a.913.913 0 1 1 0-1.826h2.769a.914.914 0 0 1 0 1.826zM34.592 20.415h-3.648a.913.913 0 1 1 0-1.824h3.648a.91.91 0 0 1 .911.912.91.91 0 0 1-.911.912zM9.057 20.415H5.408a.91.91 0 0 1-.911-.912.91.91 0 0 1 .911-.912h3.648a.911.911 0 1 1 .001 1.824zM20 9.474a.912.912 0 0 1-.914-.912v-3.65a.913.913 0 0 1 1.826 0v3.649a.911.911 0 0 1-.912.913zM30.314 30.733a.908.908 0 0 1-.644-.268l-2.579-2.58a.913.913 0 1 1 1.29-1.289l2.579 2.579a.913.913 0 0 1-.646 1.558zM12.26 12.679a.914.914 0 0 1-.646-.268L9.037 9.833a.914.914 0 0 1 1.29-1.293l2.579 2.579a.913.913 0 0 1-.646 1.56zM9.682 30.733a.913.913 0 0 1-.645-1.558l2.581-2.581a.91.91 0 0 1 1.288 0 .914.914 0 0 1 0 1.293l-2.579 2.58a.91.91 0 0 1-.645.266zM27.738 12.679a.913.913 0 0 1-.646-1.558l2.579-2.579a.913.913 0 1 1 1.29 1.289l-2.577 2.578a.908.908 0 0 1-.646.27z" />
      </g>
    ),
    done: (
      <g stroke={fill} strokeLinecap="round" strokeWidth={2}>
        <path d="m9 10 3.258 2.444a1 1 0 0 0 1.353-.142L20 5" />
        <path d="M21 12a9 9 0 1 1-6.67-8.693" />
      </g>
    ),
    declined: (
      <g fill={fill}>
        <path d="m217.2 222.6-29.4-65.1c-3.5-8.2-9.7-14.3-17.4-17 2-2.3 3.5-5.1 4.1-8.3l9.5-47.5c1.8-9.2-3.8-18.2-12.7-20.6 6.2-6.4 10-15.1 10-24.8 0-19.7-15.9-35.6-35.6-35.6-19.7 0-35.6 15.9-35.6 35.6 0 19.7 15.9 35.6 35.6 35.6 1.4 0 2.9-.1 4.3-.3-.4 1-.7 2-.9 3.1l-3.4 17-34.2-30.6-.1-.1c-10.6-9.4-28.4-9.5-42.9 8-17.2 20.7-39.2 72.7-47.2 126-4.3 28 17.4 53.3 45.8 53.3h1.4c6.2 0 11.3-1.5 15.6-4.1 1.7-.8 3.4-1.8 4.9-3.1l67.5-57.5 23.8 52.7c3.4 7.5 10.7 11.9 18.4 11.9 2.8 0 5.6-.6 8.3-1.8 10.3-4.7 14.8-16.7 10.2-26.8zm-108.5-48.2 11.3-54.8 25.1 22.5c.4.3.8.7 1.2 1-1.4.8-2.7 1.7-4 2.7l-33.6 28.6z" />
      </g>
    ),
    all: (
      <g fill={fill}>
        <path d="M41 53.1c9.1 0 16.6 7.4 16.6 16.6S50.2 86.2 41 86.2s-16.6-7.4-16.6-16.6S31.9 53.1 41 53.1zm43.7 0c9.1 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.5-16.6 16.6-16.6zM62.2 11.9c9.1 0 16.6 7.4 16.6 16.6S71.4 45 62.2 45s-16.6-7.4-16.6-16.6 7.5-16.5 16.6-16.5zm44.7 0c9.1 0 16.6 7.4 16.6 16.6S116.1 45 106.9 45s-16.6-7.4-16.6-16.6 7.5-16.5 16.6-16.5zm42.4 0c9.1 0 16.6 7.4 16.6 16.6S158.5 45 149.3 45s-16.6-7.4-16.6-16.6 7.5-16.5 16.6-16.5zm42.2 0c9.1 0 16.6 7.4 16.6 16.6S200.7 45 191.5 45 175 37.6 175 28.5s7.4-16.6 16.5-16.6zm-20.4 41.2c9.1 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6c-9.1 0-16.6-7.4-16.6-16.6s7.4-16.6 16.6-16.6zm-45 0c9.1 0 16.6 7.4 16.6 16.6 0 9.1-7.4 16.6-16.6 16.6-9.2 0-16.6-7.4-16.6-16.6 0-9.2 7.4-16.6 16.6-16.6zm88.5 0c9.1 0 16.6 7.4 16.6 16.6 0 9.1-7.4 16.6-16.6 16.6-9.2 0-16.6-7.4-16.6-16.6.1-9.2 7.5-16.6 16.6-16.6zm-173.5.4c9 0 16.3 7.3 16.3 16.3s-7.3 16.3-16.3 16.3-16.3-7.3-16.3-16.3 7.3-16.3 16.3-16.3zm18.4 35.8H22.2c-11.3 0-18.5 9.3-18.5 21.1V164c0 9.7 12.7 9.7 12.7 0v-50.2c0-1.2 1-2 2-2 1.2 0 2 .8 2 2v121.8c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V175c0-1.2 1-2 2-2h.4c1.2 0 2 1 2 2v60.6c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V113.7c0-1.2 1-2 2-2 1.2 0 2 1 2 2v50.4c0 9.7 12.7 9.7 12.7 0v-53.6c.3-11.9-6.8-21.2-18.4-21.2zm85.2 0h-37.4c-11.3 0-18.5 9.3-18.5 21.1V164c0 9.7 12.7 9.7 12.7 0v-50.2c0-1.2 1-2 2-2 1.2 0 2 .8 2 2v121.8c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V175c0-1.2 1-2 2-2h.4c1.2 0 2 1 2 2v60.6c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V113.7c0-1.2 1-2 2-2 1.2 0 2 1 2 2v50.4c0 9.7 12.7 9.7 12.7 0v-53.6c.4-11.9-6.7-21.2-18.3-21.2zm89 0h-37.4c-11.3 0-18.5 9.3-18.5 21.1V164c0 9.7 12.7 9.7 12.7 0v-50.2c0-1.2 1-2 2-2 1.2 0 2 .8 2 2v121.8c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V175c0-1.2 1-2 2-2h.4c1.2 0 2 1 2 2v60.6c0 5 4 9.1 9.1 9.1 5 0 9.1-4 9.1-9.1V113.7c0-1.2 1-2 2-2 1.2 0 2 1 2 2v50.4c0 9.7 12.7 9.7 12.7 0v-53.6c.4-11.9-6.7-21.2-18.3-21.2z" />
      </g>
    ),
    idea: (
      <>
        <path
          d="M212.17 435.162v33.008c0 24.207 19.623 43.83 43.83 43.83 24.207 0 43.83-19.623 43.83-43.83v-33.008h-87.66z"
          style={{
            fill: "#c7cfe2",
          }}
        />
        <path
          d="M245.362 468.17v-33.008H212.17v33.008c0 24.207 19.623 43.83 43.83 43.83a43.668 43.668 0 0 0 16.596-3.262c-15.975-6.542-27.234-22.236-27.234-40.568z"
          style={{
            opacity: 0.1,
            enableBackground: "new",
          }}
        />
        <path
          d="M257.892 86.994c-75.51-1.022-138.722 61.303-138.722 136.819 0 30.098 9.726 57.921 26.195 80.513 26.43 44.007 38.985 64.51 42.774 91.373 1.625 11.518 11.466 20.091 23.097 20.091h89.53c11.631 0 21.472-8.573 23.097-20.091 3.79-26.863 16.345-47.366 42.774-91.373 16.47-22.592 26.195-50.415 26.195-80.513.001-74.938-60.242-135.808-134.94-136.819z"
          style={{
            fill: "#ffd782",
          }}
        />
        <path
          d="M232.394 395.699c-3.79-26.863-16.344-47.366-42.774-91.373-16.47-22.592-26.195-50.415-26.195-80.513 0-67.413 50.377-124.309 114.905-135.017a137.706 137.706 0 0 0-20.438-1.802c-75.51-1.022-138.722 61.303-138.722 136.819 0 30.098 9.726 57.921 26.195 80.513 26.431 44.008 38.984 64.51 42.774 91.373 1.625 11.518 11.465 20.09 23.097 20.09h44.256c-11.632.001-21.474-8.573-23.098-20.09z"
          style={{
            opacity: 0.1,
            enableBackground: "new",
          }}
        />
        <path
          d="m317.798 435.162-61.797-19.373-61.797 19.373c-10.7 0-19.373 8.674-19.373 19.373 0 10.7 8.674 19.374 19.373 19.374h123.595c10.7 0 19.373-8.674 19.373-19.374-.001-10.698-8.675-19.373-19.374-19.373z"
          style={{
            fill: "#b4bbcc",
          }}
        />
        <path
          d="M219.085 454.536c0-10.7 8.674-19.373 19.374-19.373l39.67-12.436-22.128-6.937-61.797 19.373c-10.7 0-19.374 8.674-19.374 19.373 0 10.7 8.674 19.374 19.374 19.374h44.256c-10.701-.001-19.375-8.674-19.375-19.374z"
          style={{
            opacity: 0.1,
            enableBackground: "new",
          }}
        />
        <path
          d="M317.798 396.416H194.204c-10.7 0-19.373 8.674-19.373 19.373 0 10.7 8.674 19.373 19.373 19.373h123.595c10.7 0 19.373-8.674 19.373-19.373-.001-10.699-8.675-19.373-19.374-19.373z"
          style={{
            fill: "#c7cfe2",
          }}
        />
        <path
          d="M219.085 415.79c0-10.7 8.674-19.373 19.374-19.373h-44.256c-10.7 0-19.374 8.674-19.374 19.373 0 10.7 8.674 19.373 19.374 19.373h44.256c-10.7-.001-19.374-8.674-19.374-19.373z"
          style={{
            opacity: 0.1,
            enableBackground: "new",
          }}
        />
        <path
          d="M256.001 61.698a8.297 8.297 0 0 1-8.298-8.298V8.298c0-4.583 3.714-8.298 8.298-8.298s8.298 3.715 8.298 8.298V53.4a8.298 8.298 0 0 1-8.298 8.298zM154.169 87.636a8.296 8.296 0 0 1-7.294-4.33L125.3 43.698a8.298 8.298 0 1 1 14.573-7.938l21.575 39.608a8.298 8.298 0 0 1-7.279 12.268zM77.13 159.126a8.255 8.255 0 0 1-4.493-1.328l-37.893-24.462a8.298 8.298 0 0 1 9-13.943l37.893 24.462a8.298 8.298 0 0 1 2.471 11.472 8.287 8.287 0 0 1-6.978 3.799zM357.832 87.636a8.298 8.298 0 0 1-7.279-12.268l21.575-39.608a8.298 8.298 0 1 1 14.573 7.938l-21.575 39.608a8.294 8.294 0 0 1-7.294 4.33zM434.871 159.126a8.297 8.297 0 0 1-4.508-15.27l37.893-24.462c3.848-2.485 8.985-1.38 11.471 2.471s1.38 8.987-2.471 11.472l-37.893 24.462a8.254 8.254 0 0 1-4.492 1.327z"
          style={{
            fill: "#ffd782",
          }}
        />
      </>
    ),
    dislike: (
      <g fill={fill}>
        <path d="M15.609 5.5v10.16c0 .4-.12.79-.34 1.12l-2.73 4.06c-.43.65-1.5 1.11-2.41.77-.98-.33-1.63-1.43-1.42-2.41l.52-3.27c.04-.3-.04-.57-.21-.78a.93.93 0 0 0-.69-.31h-4.11c-.79 0-1.47-.32-1.87-.88-.38-.54-.45-1.24-.2-1.95l2.46-7.49c.31-1.24 1.66-2.25 3-2.25h3.9c.67 0 1.61.23 2.04.66l1.28.99a2 2 0 0 1 .78 1.58ZM18.79 17.608h1.03c1.55 0 2.18-.6 2.18-2.08V5.478c0-1.48-.63-2.08-2.18-2.08h-1.03c-1.55 0-2.18.6-2.18 2.08v10.06c0 1.47.63 2.07 2.18 2.07Z" />
      </g>
    ),
    addChoicesZakl: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7.5 10.5h.01m4.49 0h.01m4.49 0h.01M9.9 19.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735ZM8 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
      />
    ),
    deleteChoicesZakl: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m9.5 8 5 5m0-5-5 5m.4 6.2 1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L14.1 19.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C21 15.597 21 14.898 21 13.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C5.403 18 6.102 18 7.5 18c.489 0 .733 0 .96.053a2 2 0 0 1 .821.412c.18.149.326.344.619.735Z"
      />
    ),
    arrowDown: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 4v16m0 0 6-6m-6 6-6-6"
      />
    ),
    arrowUp: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 20V4m0 0-6 6m6-6 6 6"
      />
    ),
    cut: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4.5 8.6 21 17m0-10L4.5 15.4M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      />
    ),
    duplicate: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10.5 2.003c-.675.009-1.08.048-1.408.215a2 2 0 0 0-.874.874c-.167.328-.206.733-.215 1.408M19.5 2.003c.675.009 1.08.048 1.408.215a2 2 0 0 1 .874.874c.167.328.206.733.215 1.408m0 9c-.009.675-.048 1.08-.215 1.408a2 2 0 0 1-.874.874c-.328.167-.733.206-1.408.215M22 8v2m-8-8h2M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22Z"
      />
    ),
    delete: (
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
      />
    ),
    extract: (
      <>
        <path
          d="M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.1789 3.17892 12.1024 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48003 12 6.62004 12 6.727 12.0545C6.82108 12.1024 6.89757 12.1789 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.8211 6.82108 15.8976 6.727 15.9455C6.62004 16 6.48003 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.8976 3.10243 15.8211 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 2.8C2 2.51997 2 2.37996 2.0545 2.273C2.10243 2.17892 2.17892 2.10243 2.273 2.0545C2.37996 2 2.51997 2 2.8 2H5.2C5.48003 2 5.62004 2 5.727 2.0545C5.82108 2.10243 5.89757 2.17892 5.9455 2.273C6 2.37996 6 2.51997 6 2.8V5.2C6 5.48003 6 5.62004 5.9455 5.727C5.89757 5.82108 5.82108 5.89757 5.727 5.9455C5.62004 6 5.48003 6 5.2 6H2.8C2.51997 6 2.37996 6 2.273 5.9455C2.17892 5.89757 2.10243 5.82108 2.0545 5.727C2 5.62004 2 5.48003 2 5.2V2.8Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  };

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {svgPaths[title]}
    </svg>
  );
};

export default Icon;
